import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sandstone',
  templateUrl: './sandstone.component.html',
  styleUrls: ['./sandstone.component.css']
})
export class SandstoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
